module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gDGTJ"))).then(() => parcelRequire('hEqeo'));